import { createSlice } from "@reduxjs/toolkit";

const initialImportMutationBankState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  importMutationBankForEdit: undefined,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const importMutationBankSlice = createSlice({
  name: "importMutationBank",
  initialState: initialImportMutationBankState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getImportMutationBankById
    importMutationBankFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.importMutationBankForEdit =
        action.payload.importMutationBankForEdit;
    },
    // findImportMutationBank
    importMutationBanksFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    importMutationBankReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
  },
});
